import {
    makeStyles,
    createStyles,
    Theme,
} from '@bb-ui/react-library/dist/components/styles';

import { illuminateColors } from '../../utilities/sharedStyles';

const styles = (theme: Theme) =>
    createStyles({
        badge: {
            '& span': {
                backgroundColor: illuminateColors.brandGreen,
                color: illuminateColors.badgeAccentText,
                fontSize: theme.typography.fontSizeSmall,
                fontWeight: theme.typography.fontWeightSemiBold,
                letterSpacing: '1px',
            },
        },
    });

const options = {
    name: 'ListNavBadge-',
};

export const useStyles = makeStyles(styles, options);
